import { weijuConnections } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function Connections() {
  return (
    <section id="connections" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 border border-primary-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              连接谁
            </div>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              连接消费者、餐饮商家与供应链三端
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              味聚以消费者需求为入口，以餐饮场景为核心，以供应链为支撑，把人、店、货、场连接起来。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {weijuConnections.map((conn, idx) => (
            <Reveal key={conn.name} delay={idx * 100}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-24 h-24 rounded-full bg-accent-500/5 blur-2xl pointer-events-none"></div>
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${conn.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 font-heading font-bold text-xl text-foreground-950">{conn.name}</h3>
                <p className="mt-1 text-sm font-medium text-accent-700 whitespace-nowrap">{conn.subtitle}</p>
                <ul className="mt-4 space-y-2">
                  {conn.points.map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
                      <i className="ri-check-line text-accent-500 mt-0.5"></i>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}